import { clx, DropdownList, DropdownListItem } from "@hm/fundamental"

import type { FilterOption } from "../../../model/types"

interface SelectDropdownProps {
	listboxId: string
	deferredQuery: string
	filteredOptions: FilterOption[]
	value: string | number | undefined
	dropdownClassName?: string
	"data-cy": string
	onSelect: (value: string | number) => void
}

export const SelectDropdown: React.FC<SelectDropdownProps> = ({
	listboxId,
	deferredQuery,
	filteredOptions,
	value,
	dropdownClassName = "max-h-[312px]",
	onSelect,
	"data-cy": dataCy,
}) => {
	return (
		<div
			id={listboxId}
			className={clx(
				"absolute z-50 mt-1 w-full overflow-y-auto rounded-lg",
				"border border-solid border-border",
				"bg-container_background_elevated",
				"shadow-user_menu",
				dropdownClassName,
			)}
			data-cy={`${dataCy}-dropdown`}
		>
			<DropdownList isOpen key={`${deferredQuery}-${String(value)}`}>
				{filteredOptions.map(option => (
					<DropdownListItem
						key={option.value}
						title={
							option.customIcon ? (
								<span className="flex items-center gap-2">
									{option.customIcon}
									<span>{option.label}</span>
								</span>
							) : (
								option.label
							)
						}
						value={option.value}
						isSelected={option.value === value}
						onClick={() => onSelect(option.value)}
						data-cy={`${dataCy}-option-${option.value}`}
					/>
				))}
			</DropdownList>
		</div>
	)
}
